import groupBy from 'lodash/groupBy';

import {ChartType, ResourceType} from 'common/report/constants';
import {CommonToFunnelChartTypeMap, FunnelBookmark} from 'common/report/models/funnels/types';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {LogicalOperator} from 'common/widgets/property-filter-menu/models/types';
import {bookmarkFilterByCohortToCohortFilters, getFilterByCohorts} from 'common/widgets/query-block/filter-menu/util';

export function getBookmarkParamsWithChartType(
  bookmarkParams: FunnelBookmark,
  chartTypeOverride: ChartType,
): FunnelBookmark {
  if (!CommonToFunnelChartTypeMap[chartTypeOverride]) {
    throw new Error(`unsupported chart type: ${chartTypeOverride}`);
  }

  return {
    ...bookmarkParams,
    chart_type: CommonToFunnelChartTypeMap[chartTypeOverride],
  };
}

export function getBookmarkParamsWithDateRange(
  bookmarkParams: FunnelBookmark,
  dateRangeOverride: DateRange,
): FunnelBookmark {
  return {
    ...bookmarkParams,
    date_range: dateRangeOverride.getBookmarkFormat(),
  };
}

export function getBookmarkParamsWithAdditionalFilters(
  bookmarkParams: FunnelBookmark,
  additionalFilters: PropertyFilter[],
): FunnelBookmark {
  const groupedFilters = groupBy(additionalFilters, (filter) => filter.resourceType);

  const filterByEvent = {
    operator: LogicalOperator.And,
    children: [
      ...(bookmarkParams.filter_by_event?.children ?? []),
      ...(groupedFilters[ResourceType.Event] ?? []).map((filter) => ({event: filter.getAttributes()})),
      ...(groupedFilters[ResourceType.User] ?? []).map((filter) => ({user: filter.getAttributes()})),
    ],
  };

  const bookmarkFilterByCohort = bookmarkFilterByCohortToCohortFilters(bookmarkParams.filter_by_cohort);
  const cohortPropertyFilters = [...(groupedFilters[ResourceType.Cohort] ?? []), ...bookmarkFilterByCohort];

  const filterByCohort = cohortPropertyFilters.length ? getFilterByCohorts(cohortPropertyFilters) : {};

  return {
    ...bookmarkParams,
    ...(filterByEvent.children.length ? {filter_by_event: filterByEvent} : {}),
    filter_by_cohort: JSON.stringify(filterByCohort),
  };
}
